<script setup>
import { useToastStore } from '@/stores/toast'
import Toast from './Toast.vue'

const toast = useToastStore()
</script>

<template>
  <Teleport to="body">
    <div
      aria-live="polite"
      aria-atomic="false"
      class="fixed bottom-6 right-4 z-[100] flex flex-col gap-2 sm:right-6"
    >
      <TransitionGroup
        enter-active-class="transition duration-300 ease-out"
        enter-from-class="translate-y-4 opacity-0"
        enter-to-class="translate-y-0 opacity-100"
        leave-active-class="transition duration-200 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <Toast
          v-for="t in toast.toasts"
          :key="t.id"
          :id="t.id"
          :message="t.message"
          :type="t.type"
          @dismiss="toast.remove"
        />
      </TransitionGroup>
    </div>
  </Teleport>
</template>
